
export class Analytics {
    private get _dataLayer() {
        return (window as any).dataLayer || [];
    }

    constructor() {
    }

    PushEvent = (category: string = undefined,
        action: string = undefined,
        label: string = undefined,
        value: number = undefined,
        event: string = undefined) => {

        this._dataLayer.push({
            Category: category,
            Action: action,
            Label: label,
            Value: value,
            event: event
        });
    }

    PushSearchTerm = (value: string) => {
        this.PushEvent(
            undefined,
            value != null && value != undefined ? value.toLowerCase() : undefined,
            (window as any).MemberSegment != null && (window as any).MemberSegment != undefined ? (window as any).MemberSegment : 'Guest',
            undefined,
            "SearchEvent");
    }

    PushMemberSegment = () => {
        if ((window as any).MemberSegment) {
            this._dataLayer.push({
                'MemberSegment': (window as any).MemberSegment,
                'event': 'MemberSegmentEvent'
            })
        }
    }
}


// WEBPACK FOOTER //
// ./Static/javascript/modules/analytics.ts